import 'suneditor/dist/css/suneditor.min.css'

type EditorWrapperProps = React.HTMLAttributes<HTMLDivElement>

const EditorWrapper = (props: EditorWrapperProps) => {
  return <div className="sun-editor-editable" {...props} />
}

export default EditorWrapper
